import React from 'react';
import './Spinner.scss';

const Spinner = () => {
  return (
    <div className="loadingio-spinner-eclipse-6k77a25kvoc">
      <div className="ldio-y6dphe9xoic">
        <div></div>
      </div>
    </div>
  );
}

export default Spinner;